// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1cbcf0d5","453":"a7e043c0","455":"63ed7644","977":"db57bdfb"}[chunkId] + ".chunk.js";
};